import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import styled from 'astroturf/react'
const textColorLevel3 = 'var(--text-color-level3, rgba(26, 26, 26, 0.1))'
const colorBgWhiteL1 = 'var(--color-bg-white-l-1, rgba(255, 255, 255, 1))'
import { FixedContainer } from '@calendly/ui/components/fixed-container'

import { isPollSelector } from 'selectors/event_type'
import { selectedSpotsSelector } from 'selectors/calendar'
import { calendarSpotsCountSelector } from 'selectors/calendars'
import { confirmSpot, spotSelectionError } from 'actions/spot'

import PollVotesWarning from './poll_votes_warning'
import ActionBar from './action_bar'
import _Container from "index-Container.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/footer/index.js?styleId=Container";


const MIN_WARNING_SPOT_COUNT = 4

const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: _Container,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    as: FixedContainer,
    fixedWhen: useDeviceType('isPhone')
  })
})

const Footer = () => {
  const dispatch = useDispatch()
  const isPoll = useSelector(isPollSelector)
  const selectedSpots = useSelector(selectedSpotsSelector)
  const calendarSpotsCount = useSelector(calendarSpotsCountSelector)
  const [showPollVotesWarning, setShowPollVotesWarning] = useState(false)

  const shouldShowPollVotesWarning = selectedSpots.length === 1 && calendarSpotsCount >= MIN_WARNING_SPOT_COUNT

  useEffect(() => {
    if (!shouldShowPollVotesWarning) {
      setShowPollVotesWarning(false)
    }
  }, [shouldShowPollVotesWarning])

  const next = () => {
    if (shouldShowPollVotesWarning && !showPollVotesWarning) {
      setShowPollVotesWarning(true)
      return
    }

    if (selectedSpots.length >= 1) {
      dispatch(confirmSpot(selectedSpots[0]))
    } else {
      dispatch(spotSelectionError())
    }
  }

  if (!isPoll) return null

  return (
    <Container>
      {showPollVotesWarning ? <PollVotesWarning onConfirm={next} /> : <ActionBar onConfirm={next} />}
    </Container>
  )
}

export default Footer
